// Stored retail-order line statuses supported by Seller MyShop. Keep return
// and replacement states visible here; omitting them makes valid orders look
// absent when sellers need to process the after-sale workflow.
export const SELLER_ORDER_STATUSES = [
  "Not processed",
  "Processing",
  "Shipped",
  "Delivered",
  "Cancelled",
  "Return or replace",
  "Return Back",
  "Replace",
];

